import React, { useState, useEffect } from 'react';

import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

import { useHistory, useRouteMatch } from 'react-router';
import MerchantLayout from '../../layout/MerchantLayout';
import DataCard from '../../components/Cards/DataCard';
import OpenScanner from '../../components/Scan/OpenScanner';
import { ScanStatistics } from '../../types/crm';
import { getMerchantDataPasses, getStatistics } from '../../services/c2dcrm';

import { ROUTES } from '../../constants/route';
import { useAuth } from '../../hooks/useAuth';
import { useSnackbar } from '../../components/Context/SnackbarContext';
import { DataPass } from '../../types/dataPassport';

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'grid',
    placeItems: 'center',
  },
  grid: {
    display: 'grid',
    gridGap: '32px',

    flexWrap: 'nowrap',
    placeItems: 'center',
    maxWidth: '312px',

    [theme.breakpoints.up('sm')]: {
      maxWidth: '442px',
    },

    [theme.breakpoints.up('md')]: {
      maxWidth: '540px',
    },
  },
  wide: {
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
  },
}));

const ScanLandingPage: React.FC = () => {
  const match = useRouteMatch<{ dataPassId: string }>(ROUTES.MERCHANT_DATA_PASS_TERMINAL);
  const classes = useStyles();
  const history = useHistory();
  const [data, setData] = useState<ScanStatistics>();
  const [dataPassport, setDataPassport] = useState<DataPass | undefined>(undefined);
  const { token } = useAuth();
  const { openSnackbar } = useSnackbar();

  useEffect(() => {
    const fetchDataPassport = async () => {
      try {
        const response = await getMerchantDataPasses(token);
        if (response) {
          const pass = response.data.find((p) => p.id === match?.params.dataPassId);

          if (pass) {
            const statistics = await getStatistics(pass.id, token);
            if (statistics) setData(statistics.data);
            setDataPassport(pass);
          } else {
            history.replace(ROUTES.MERCHANT);
          }
        }
      } catch (error) {
        openSnackbar('Error: Failed to load Data Pass.');
      }
    };

    fetchDataPassport();
  }, []);

  const openScanner = () => {
    history.push(`/data-pass/${match?.params?.dataPassId}/scanner`);
  };

  if (!dataPassport) return null;

  return (
    <MerchantLayout>
      <div className={classes.container}>
        <Grid
          container
          alignItems="center"
          justifyContent="center"
          direction="column"
          spacing={4}
          className={classes.grid}
         >
          <OpenScanner onOpenScanner={openScanner} />
          <Typography variant="h1" color="primary">
            {dataPassport.title}, Transaction Details
          </Typography>
          <DataCard data={data} />
        </Grid>
      </div>
    </MerchantLayout>
  );
};

export default ScanLandingPage;
